var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c("el-input", {
        ref: "mblHeader",
        staticStyle: { width: "70px" },
        attrs: { disabled: _vm.editable, maxlength: "3", no: "1" },
        on: {
          input: _vm.mblHeaderChangeHandler,
          focus: function($event) {
            return _vm.onFocus("headerFocused")
          },
          blur: function($event) {
            return _vm.onBlur("headerFocused")
          }
        },
        model: {
          value: _vm.prefix,
          callback: function($$v) {
            _vm.prefix = $$v
          },
          expression: "prefix"
        }
      }),
      _c(
        "span",
        { staticStyle: { "padding-right": "1.5px", "padding-left": "1.5px" } },
        [_vm._v("-")]
      ),
      _c("el-input", {
        ref: "mblFooter",
        staticStyle: { width: "130px" },
        attrs: { disabled: _vm.editable, maxlength: "8", no: "2" },
        on: {
          input: _vm.mblFooterChangeHandler,
          focus: function($event) {
            return _vm.onFocus("footerFocused")
          },
          blur: function($event) {
            return _vm.onBlur("footerFocused")
          }
        },
        model: {
          value: _vm.mawbNo,
          callback: function($$v) {
            _vm.mawbNo = $$v
          },
          expression: "mawbNo"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }